/* AntiFight — Paket G: koleksiyon açıklaması önizleme + sonsuz kaydırma yükleme göstergesi (yalnız görünüm) */
(() => {
  const LINES = 4;
  const desc = document.querySelector('.collection-wrapper ~ *, [class*="__text_twGGkJ"]') && document.querySelector('[class*="__text_twGGkJ"]');
  if (desc && desc.textContent.trim()) {
    const target = desc.querySelector(':scope > *') && desc.children.length === 1 ? desc : desc;
    const probe = target.querySelector('p, li, div') || target;
    const lh = parseFloat(getComputedStyle(probe).lineHeight) || 24;
    if (target.scrollHeight > lh * (LINES + 1)) {
      target.style.setProperty('--af-desc-max', (lh * LINES) + 'px');
      target.classList.add('af-desc--clamped');
      const btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'af-desc-toggle'; btn.setAttribute('aria-expanded', 'false'); btn.textContent = 'Devamını Gör';
      btn.addEventListener('click', () => {
        const open = target.classList.toggle('af-desc--clamped') === false;
        btn.setAttribute('aria-expanded', String(open)); btn.textContent = open ? 'Daha Az Göster' : 'Devamını Gör';
      });
      target.insertAdjacentElement('afterend', btn);
    }
  }
  const list = document.querySelector('results-list[infinite-scroll="true"]');
  if (list && window.fetch && !window.__afFetchPatched) {
    window.__afFetchPatched = true;
    const ind = document.createElement('div'); ind.className = 'af-loading-indicator'; ind.setAttribute('role', 'status'); ind.textContent = 'Ürünler yükleniyor…';
    const grid = list.querySelector('.product-grid'); if (grid) grid.insertAdjacentElement('afterend', ind);
    const orig = window.fetch; let active = 0;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isPage = /[?&]page=\d+/.test(url) && url.indexOf(location.pathname) !== -1;
      if (isPage) { active++; list.setAttribute('af-loading', ''); }
      const p = orig.apply(this, arguments);
      if (isPage) p.finally(() => { active = Math.max(0, active - 1); if (!active) list.removeAttribute('af-loading'); });
      return p;
    };
  }
})();
